import { render } from "./NoticeModify.vue?vue&type=template&id=044fcf74"
import script from "./NoticeModify.vue?vue&type=script&lang=js"
export * from "./NoticeModify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__